<template>
    <div>
        <!-- Antes de cadastrar: o aluno já existe na SED? (um cadastro repetido vira RA duplicado e não pode ser desfeito) -->
        <el-form ref="form" :model="filtro" label-position="top" @submit.native.prevent="buscar">
            <!-- Com RA, CPF ou certidão a SED identifica o aluno sozinha; sem eles, nome e nascimento são obrigatórios. -->
            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="RA do aluno" prop="ra">
                        <el-input v-model="filtro.ra" maxlength="20" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="CPF do aluno" prop="cpf">
                        <el-input v-model="filtro.cpf" v-mask="'###.###.###-##'" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Certidão de nascimento (nova)" prop="registro_nasc_novo">
                        <el-input v-model="filtro.registro_nasc_novo" maxlength="40" placeholder="32 dígitos" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="10" :md="10">
                    <el-form-item label="Nome completo do aluno" prop="nome" :rules="temDocumento ? [] : [$requiredBlur]">
                        <el-input v-model="filtro.nome" maxlength="100" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="5" :md="5">
                    <el-form-item label="Data de nascimento" prop="data_nascimento" :rules="temDocumento ? [$dataBlur] : [$requiredBlur, $dataBlur]">
                        <el-input v-model="filtro.data_nascimento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="9" :md="9">
                    <el-form-item label="Nome da mãe (filiação 1)" prop="mae">
                        <el-input v-model="filtro.mae" maxlength="100" @input="limpar"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-loading="carregando" style="min-height: 20px;">

            <template v-if="buscou && candidatos.length > 0">

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 150px;">RA</th>
                                <th>Nome</th>
                                <th>Instituição</th>
                                <th style="width: 130px;">Situação</th>
                                <th style="width: 190px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in candidatos" :key="c.ra.numero">
                                <td>{{ c.ra.numero }}-{{ c.ra.digito }}/{{ c.ra.uf }}</td>
                                <td>
                                    {{ c.nome }}
                                    <br><small style="color: #909399;"><i>{{ c.data_nascimento || filtro.data_nascimento }}</i></small>
                                </td>
                                <td>
                                    <template v-if="c.matricula_ativa">
                                        {{ c.matricula_ativa.escola }}
                                        <br><small style="color: #909399;">{{ c.matricula_ativa.municipio }} · {{ c.matricula_ativa.rede }} · {{ c.matricula_ativa.serie }}</small>
                                        <!-- Matrícula ativa fora da rede: a SED vai exigir a inscrição de transferência (o sistema abre o diálogo na matrícula) -->
                                        <br v-if="avisoInscricao(c)"><small v-if="avisoInscricao(c)" style="color: #ff0000;">Matriculado em outra escola — exige inscrição de transferência</small>
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>{{ c.matricula_ativa ? 'MATRICULADO' : '-' }}</td>
                                <td class="u-text-center acao">

                                    <!-- Já no SMGE: com matrícula ativa abre o dossiê; sem ela vai direto ao passo a passo da matrícula -->
                                    <template v-if="c.ja_vinculado_no_smge">
                                        <a v-if="c.matricula_ativa && c.matricula_ativa.na_nossa_rede" @click="$emit('abrirAluno', c.ja_vinculado_no_smge.aluno_id)" href="javascript:void(0)" title="Abrir o cadastro do aluno">ABRIR CADASTRO</a>
                                        <!-- Matrícula ativa fora da rede: reaproveita o cadastro que já está no SMGE e segue para a matrícula (a inscrição de transferência abre ali) -->
                                        <a v-else-if="c.matricula_ativa" @click="$emit('matricular', c.ja_vinculado_no_smge.aluno_id)" href="javascript:void(0)">INSCRIÇÃO DE TRANSFERÊNCIA</a>
                                        <a v-else @click="$emit('matricular', c.ja_vinculado_no_smge.aluno_id)" href="javascript:void(0)">REALIZAR MATRÍCULA</a>
                                    </template>

                                    <!-- Matrícula ativa em escola da rede: traz o aluno e a matrícula, sem recadastrar -->
                                    <template v-else-if="c.matricula_ativa && c.matricula_ativa.na_nossa_rede">
                                        <i v-if="importando === c.ra.numero" class="el-icon-loading"></i>
                                        <a v-else @click="importar(c)" href="javascript:void(0)">TRAZER DA SED</a>
                                    </template>

                                    <!-- Matrícula ativa fora da rede: usa a ficha da SED e segue; na matrícula o sistema abre a inscrição de transferência -->
                                    <a v-else-if="avisoInscricao(c)" @click="usar(c)" href="javascript:void(0)">INSCRIÇÃO DE TRANSFERÊNCIA</a>

                                    <!-- Sem matrícula ativa: usa a ficha da SED e segue para a matrícula -->
                                    <a v-else @click="usar(c)" href="javascript:void(0)">REALIZAR MATRÍCULA</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>

        <div class="u-text-right u-mt-10">
            <el-button @click="$emit('fechar')">Cancelar</el-button>
            <el-button v-if="!buscou" type="primary" :loading="carregando" @click="buscar">Continuar</el-button>
            <!-- 3) Não existe na SED (ou nenhum dos encontrados é ele, quando a SED não tem certeza) -->
            <el-button v-if="buscou && candidatos.length > 0 && podeCadastrarNovo" type="primary" @click="novo">Não é nenhum destes — cadastrar aluno novo</el-button>
        </div>
    </div>
</template>
<script>
import { mostrarThrow as mostrarThrowSed } from '@/shared/sed'

export default {
    props: ['cies'],
    data: () => ({
        filtro: { ra: '', nome: '', data_nascimento: '', mae: '', cpf: '', registro_nasc_novo: '' },
        carregando: false,
        buscou: false,
        candidatos: [],
        importando: null
    }),
    computed: {
        // RA, CPF ou certidão identificam o aluno sozinhos: nome e nascimento deixam de ser obrigatórios.
        temDocumento() {
            return !!(this.filtro.ra.trim() || this.filtro.cpf.replace(/\D/g, '') || this.filtro.registro_nasc_novo.trim());
        },
        // Com identificação certa (CPF, certidão ou nome + mãe + nascimento) não se cadastra outro: seria RA duplicado.
        podeCadastrarNovo() {
            return !this.candidatos.some(c => c.confianca === 'ALTA' || c.encontrado_por === 'RA_PARCIAL');
        }
    },
    methods: {
        // Matrícula ativa em escola de fora da rede (esteja o aluno já no SMGE ou não): a matrícula aqui passa pela inscrição de transferência.
        avisoInscricao(c) {
            return !!(c.matricula_ativa && !c.matricula_ativa.na_nossa_rede);
        },
        limpar() {
            this.buscou = false;
            this.candidatos = [];
            if (this.temDocumento && this.$refs.form) this.$refs.form.clearValidate(['nome', 'data_nascimento']);
        },
        buscar() {
            this.$refs.form.validate(ok => {
                if (!ok) return;

                this.carregando = true;

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/sed/aluno/buscar`, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                    this.carregando = false;

                    if (mostrarThrowSed(this, response.data)) return;

                    this.candidatos = response.data.candidatos || [];
                    this.buscou = true;

                    // Não existe na SED: segue direto para o cadastro, com o que foi digitado.
                    if (this.candidatos.length === 0) this.novo();

                }).catch((error) => { this.carregando = false; this.$store.commit('throwException', error); });
            });
        },
        usar(c) {
            this.$emit('seguir', { sed_ra: [c.ra.numero, c.ra.digito, c.ra.uf].join('|') });
        },
        novo() {
            this.$emit('seguir', { sed_novo: 1, nome: this.filtro.nome, data_nascimento: this.filtro.data_nascimento, mae: this.filtro.mae, cpf: this.filtro.cpf, registro_nasc_novo: this.filtro.registro_nasc_novo });
        },
        importar(c) {
            this.importando = c.ra.numero;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/sed/aluno/importar`, { ra: c.ra }, this.$store.getters.getHeaderAuth).then(response => {

                this.importando = null;

                if (mostrarThrowSed(this, response.data)) return;

                const n = (response.data.criadas || []).length;
                window.eventBus.$emit('alert', { msg: 'Aluno trazido da SED' + (n ? ' com ' + n + ' matrícula(s).' : '.'), type: 'success' });
                this.$emit('abrirAluno', response.data.aluno_id);

            }).catch((error) => { this.importando = null; this.$store.commit('throwException', error); });
        }
    }
}
</script>
